import React from "react";
import "./style/RecoverPassword.module.scss";
import "react-phone-input-2/lib/style.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import FInputt from "../../components/FInputt/FInputt";
import { useRecoverPassword } from "./hooks/useRecoverPassword";
import { ArrowLeftIcon } from "@heroicons/react/solid";
import PhoneInput from "react-phone-input-2";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import Fbutton from "../../components/Finputs/FButton/Fbutton";

const RecoverPassword = ({ param }) => {
  const {
    formik,
    parameters,
    route,
  } = useRecoverPassword();

  return (
    <>
      <div className="sm:border-0 sm:border-red-600 sm:h-screen sm:relative sm:grid sm:place-items-center">
        <div className="w-screen border-0 h-[22rem] sm:w-[670px] md:w-[770px] sm:shadow-2xl sm:absolute border-red-600 grid grid-rows-6 sm:grid-rows-1 grid-cols-1 sm:grid-cols-12">
          <div
            className="absolute pt-10 sm:pt-6 pl-5 sm:pl-5 z-50 cursor-pointer"
            onClick={() => {
              if (!!parameters.state) {
                route("/SignInScreen", {
                  state: {
                    phoneNumber: parameters.state.phoneNumber,
                  },
                });
              } else {
                route("/");
              }
            }}
          >
            <div className="w-11 h-11 bg-white rounded-full grid place-items-center">
              <ArrowLeftIcon className="w-6" />
            </div>
          </div>
          <img
            src={require("../../components/assets/images/3-h.png")}
            className="border-0 hidden sm:block border-red-600 w-full h-full gap-0 row-span-3 sm:grid-rows-1 col-span-7"
          />
          <img
            src={require("../../components/assets/images/3-v.png")}
            className="border-0 sm:hidden block border-red-600 w-full gap-0 row-span-3 sm:grid-rows-1 col-span-7"
          />

          <div className="border-0 absolute sm:pl-[50%] md:pl-[50%]  pt-[45%] sm:pt-0 border-blue-600 w-full sm:h-[100%] row-span-3 sm:grid-rows-1 col-span-5 sm:grid sm:items-center">
            <form
              className="text-center px-7 sm:px-6 md:px-10"
            >
              <div className="text-[27px] pt-14 sm:pt-1 px-10 font-bold">
                ¿Olvidaste tu contraseña?
              </div>
              <div className="font-regular text-[13px] sm:pt-2">
                ¡No te preocupes! Solo ingresa tu teléfono
              </div>
              <div className="border-0 mt-[15px]">
              <FInputText
                  type="PhoneInput"
                  title=""
                  placeholder="Ingresa tu teléfono"
                  value={formik.values.phoneNumber}
                  onChange={(value) => {
                    formik.setFieldValue("phoneNumber", value);
                  }}
                  errorMessage={formik.errors.phoneNumber}
                />
              </div>
              <Fbutton
                  value={"Continuar"}
                  disabled={!(formik.isValid && formik.dirty)}
                  onClick={formik.handleSubmit}
                />

            </form>
          </div>
        </div>
      </div>
      {/* <section className="h-screen gradient-formmd:h-screen">
        <div className="sm:h-screen border-0">
          <div className="flex justify-center items-center flex-wrap h-full g-6 text-gray-800 border-0 sm:bg-gray-100">
            <div className="xl:w-10/12 border-0  sm:px-20">
              <div className="block bg-white sm:shadow-lg rounded-lg sm:h-full h-screen">
                <div className="lg:flex lg:flex-wrap g-0">
                  <div className="lg:w-6/12  flex items-center lg:rounded-r-lg rounded-b-lg lg:rounded-bl-none border-0">
                    <img
                      className="w-full h-full"
                      src={require("../../components/assets/images/3.png")}
                    />
                  </div>
                  <div className="lg:w-6/12 px-4 md:px-0 flex justify-center items-center border-0">
                    <div className="md:p-12 md:mx-6">
                      <form
                        onSubmit={formik.handleSubmit}
                        className="text-center pt-10 sm:pt-0"
                      >
                        <div className=" font-semibold mt-2 text-3xl pb-2">
                          ¿Olvidaste tu contraseña?
                        </div>
                        <div className="text-sm pb-4">
                          ¡No te preocupes¡ Solo ingresa tu teléfono
                        </div>
                        <div className="mt-2">
                          <FInputt
                            type="PhoneInput"
                            name="phoneNumber"
                            value={
                              !!parameters.state
                                ? parameters.state.phoneNumber
                                : null
                            }
                            formik={formik}
                          />
                        </div>
                        <div className="m-4 pb-4 sm:pb-0">
                          <FInputt
                            type="submit"
                            title="Continuar"
                            formik={formik}
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default RecoverPassword;
